<span id="cronometroAtual">{{cronn()}}</span>
<input class="d-none" type="text" id="txtCronH" [(ngModel)]="hour" />
<input class="d-none" type="text" id="txtCronM" [(ngModel)]="minute" />
<input class="d-none" type="text" id="txtCronS" [(ngModel)]="second" />
<input class="d-none" type="text" id="txtCronMS" [(ngModel)]="millisecond" />
<button class="d-none" type="button" (click)="start()" id="btnCronStart">start</button>
<button class="d-none" type="button" (click)="pause()" id="btnCronStop">pause</button>
<button class="d-none" type="button" (click)="reset()" id="btnCronReset">reset</button>
<button class="d-none" type="button" (click)="set()" id="btnCronSet">set</button>